import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/ranking/popularity', label: '人气榜' },
  { to: '/ranking/rating', label: '评分榜' },
  { to: '/ranking/must-read', label: '必看榜' },
  { to: '/faq', label: '常见问题' },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/ranking/popularity?q=${encodeURIComponent(kw)}`);
  };

  const isActive = (to: string) => (to === '/' ? pathname === '/' : pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-50 w-full transition-colors duration-300">
      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur' : 'border-transparent bg-background-50'
        }`}
      >
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              韩漫精选榜
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <form onSubmit={handleSearch} className="flex items-center overflow-hidden rounded-full border border-background-200 bg-background-100/60 focus-within:border-primary-300">
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索韩漫"
                className="w-40 bg-transparent px-4 py-2 text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
              />
              <button type="submit" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600" aria-label="搜索">
                <i className="ri-search-line text-sm" />
              </button>
            </form>
            <Link
              to="/ranking/popularity"
              className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看热门
            </Link>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-950 hover:bg-background-100 md:hidden"
            aria-label="菜单"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`rounded-lg px-4 py-3 text-sm font-medium ${
                    isActive(link.to) ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
            <form onSubmit={handleSearch} className="mt-3 flex items-center gap-2">
              <div className="flex flex-1 items-center overflow-hidden rounded-full border border-background-200 bg-background-100/60">
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索韩漫"
                  className="w-full bg-transparent px-4 py-2.5 text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
                />
              </div>
              <button type="submit" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50" aria-label="搜索">
                <i className="ri-search-line text-sm" />
              </button>
            </form>
          </div>
        )}
      </div>
    </header>
  );
}